<div class="justify-content-end dynamic-form">
    <button (click)="buttonStatus()" #aButton [disabled]="form.invalid || field['disabled']"
        [tabIndex]="field['name'] == 'Save' ? field['tabIndex'] : 0"
        [ngClass]="field['name'] != 'Save' ? 'btn btn-test btn-small' : 'btn btn-warning btn-small'">
        <i *ngIf="field['name'] == 'Test'" class="feather ft-zap"></i>
        {{field['name'] }}</button>
</div>